import { Logger } from '../core/logger';

export class ReconnectionStrategy {
  private attempt = 0;
  private readonly maxAttempts = 10;
  private readonly baseDelay = 1000; // 1 second
  private readonly maxDelay = 30000; // 30 seconds
  private logger: Logger;

  constructor(logger: Logger) {
    this.logger = logger;
  }

  getNextDelay(): number | null {
    if (this.attempt >= this.maxAttempts) {
      return null;
    }

    const delay = Math.min(
      this.baseDelay * Math.pow(2, this.attempt),
      this.maxDelay
    );

    this.attempt++;
    this.logger.debug(`Reconnection attempt ${this.attempt}/${this.maxAttempts}`);

    return delay;
  }

  reset(): void {
    this.attempt = 0;
    this.logger.debug('Reconnection strategy reset');
  }

  getAttemptCount(): number {
    return this.attempt;
  }
}
